import { TableRow, TableCell, Grid } from "@material-ui/core"
import { Add, Check } from "@material-ui/icons"
import { WarningIcon } from "App/Assets"
import ModalListKunjungan from "App/Component/layout/Penjualan/InputPenjualan/ui/Perhitungan/Modal/ModalMuat/ModalListKunjungan"
import { MasterButton, TableAction, Loading, Modal } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { instance3 } from "App/constants"
import { useDatatables } from "App/hooks"
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import React, { useState, useContext, useEffect } from "react"
import { STATUS_OPEN_DRAFT_TAGIHAN, STATUS_TUTUP_TAGIHAN } from "utils/billing"
import { MSG_ERROR_TAGIHAN_NULL, urlAddKunjungan, urlGetKunjungan } from ".."
import { FormContext } from "../../context/FormContext"
import { deleteKunjunganById, headCells, jenisRawatRender } from "./helpers"

function TabKunjungan({ setNewData, rows, loading, rowsExternal }) {
  const [showModalListKunjungan, setShowModalListKunjungan] = useState(false)
  const [showModalConfirmBedaRM, setShowModalConfirmBedaRM] = useState(false)

  const { formData, setFormData } = useContext(FormContext)
  const [kunjunganIDSelect, setKunjunganIDSelect] = useState(null)

  useEffect(() => {
    setNewData()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickSelect = async (row) => {
    if (isNull(formData.tagihan_id)) {
      defaultToastError(MSG_ERROR_TAGIHAN_NULL)
    } else {
      try {
        if (formData.rm_id !== row.patients_id) {
          setShowModalListKunjungan(false)
          setKunjunganIDSelect(row.id)
          // defaultToastError("No RM Tagihan dg No RM kunjungan tidak sama!");
          setShowModalConfirmBedaRM(true)
        } else {
          await addKunjungan(row.id)
        }
      } catch (error) {
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  const addKunjungan = async (id) => {
    const res = await instance3.post(urlAddKunjungan, {
      kunjungan_id: id,
      tagihan_id: formData.tagihan_id,
    })
    if (res.data.status === 200) {
      setFormData({
        ...formData,
        reload_final_jasmed: !formData.reload_final_jasmed,
      })
      defaultToastSuccess(res.data.message)
      setShowModalListKunjungan(false)
      await setNewData()
    } else {
      defaultToastError(res.data.message)
    }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "poolKunjunganId",
    orderByRow: ["poolKunjunganId"],
  })

  async function clickDelete(row) {
    const res = await deleteKunjunganById(row.poolKunjunganId)
    if (res.state) {
      defaultToastSuccess(res.message)
      setFormData({
        ...formData,
        reload_final_jasmed: !formData.reload_final_jasmed,
      })
      await setNewData()
    } else {
      defaultToastError(res.message)
    }
  }

  const confirmHandle = async () => {
    await addKunjungan(kunjunganIDSelect)
    setShowModalConfirmBedaRM(false)
  }

  async function clickMain(idKunjungan) {
    const res = await instance3.post("/poolKunjungan/set-main-kunjungan", {
      id_tagihan: formData.tagihan_id,
      id_kunjungan: idKunjungan,
    })
    if (res.data.status === 200) {
      setFormData({
        ...formData,
        reload_final_jasmed: !formData.reload_final_jasmed,
      })
      defaultToastSuccess(res.data.message)
      await setNewData()
    } else {
      defaultToastError(res.data.message)
    }
  }

  return (
    <>
      {showModalListKunjungan && (
        <ModalListKunjungan
          setShowModal={setShowModalListKunjungan}
          type="custom"
          handleClickSelect={handleClickSelect}
          url={urlGetKunjungan}
        />
      )}

      {showModalConfirmBedaRM && (
        <ModalConfirmBedaRM
          setShowModal={() => setShowModalConfirmBedaRM(false)}
          batalHandle={() => {
            setShowModalListKunjungan(false)
            setShowModalConfirmBedaRM(false)
          }}
          confirmHandle={confirmHandle}
        />
      )}

      {formData.status_tagihan === STATUS_OPEN_DRAFT_TAGIHAN &&
        rowsExternal.length === 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "1rem",
            }}
          >
            <MasterButton
              type={"button"}
              color="green"
              outline={true}
              onClick={() => setShowModalListKunjungan(!showModalListKunjungan)}
              name="Tambah Kunjungan"
              size="sm"
              withIcon={true}
              icon={
                <Add
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
          </div>
        )}

      <Loading show={loading} />
      <FreezeTableClient
        title="Daftar Kunjungan"
        setQ={setQ}
        withExportButton={false}
        withAddButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={data}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow hover tabIndex={-1} key={index}>
                <TableCell scope="row" padding="none" align="center">
                  {index + 1}
                </TableCell>
                <TableCell scope="row" padding="none">
                  {formData.status_tagihan !== STATUS_TUTUP_TAGIHAN && (
                    <TableAction
                      clickDelete={() => clickDelete(row)}
                      isUpdate={false}
                    />
                  )}
                </TableCell>
                <TableCell
                  scope="row"
                  padding="none"
                  align="center"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => clickMain(row?.kunjungan_id)}
                >
                  {row.is_main && <Check />}
                </TableCell>
                <TableCell align="left" width={"5%"}>
                  {row?.poolKunjunganId}
                </TableCell>
                <TableCell align="left" width={"10%"}>
                  {row?.tagihan_id}
                </TableCell>
                <TableCell align="left" width={"10%"}>
                  {row?.kunjungan_id}
                </TableCell>
                <TableCell align="left" width={"10%"}>
                  {defaultDateDisplay(row?.tanggal)}
                </TableCell>
                <TableCell align="left">{row.namaRM}</TableCell>
                <TableCell align="left" width={"5%"}>
                  {row.id_rm}
                </TableCell>
                <TableCell align="left">
                  {jenisRawatRender(row.typeofcare_code)}
                </TableCell>
                <TableCell align="left">{row.no_sep}</TableCell>
              </TableRow>
            )
          })}
      </FreezeTableClient>
    </>
  )
}

function ModalConfirmBedaRM({ setShowModal, confirmHandle, batalHandle }) {
  return (
    <>
      <Modal
        backgroundTitle="red"
        title={"Konfirmasi"}
        width={"30%"}
        show={setShowModal}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "20px",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <WarningIcon width="150px" height="150px" />
          <p className="fs-12">No RM Tagihan dg No RM kunjungan tidak sama!</p>
        </div>

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            outline={true}
            className={"mr-1 mt-1"}
            type={"button"}
            color="secondary"
            name="Batal"
            onClick={batalHandle}
            size="md"
          />
          <MasterButton
            className={"mt-1"}
            type={"button"}
            color={"danger"}
            onClick={confirmHandle}
            name={"Ya, saya yakin"}
            size="md"
          />
        </Grid>
      </Modal>
    </>
  )
}

export default TabKunjungan
